import { ActiveOrder, QueryDataError } from '@/resources/types'
import { createContext, useContext } from 'react'

export type ActiveOrdersContextType = {
  activeOrders: ActiveOrder[]
  isPollingActive: boolean
  isFromWss: boolean
  isQueryFetching: boolean
  isFetched: boolean
  queryError?: QueryDataError | null
  isActiveOrdersQueryError?: boolean
  isSellerKanbanFilterEnabled: boolean
  kanbanFilterSearchInput: string
  setKanbanFilterSearchInput: (value: string) => void
  kanbanFilterDeliveryType: number | null
  setKanbanFilterDeliveryType: (value: number | null) => void
  isKanbanFilterSearchDebouncing: boolean
}

export const ActiveOrdersContext = createContext<ActiveOrdersContextType>({
  activeOrders: [],
  isPollingActive: false,
  isFromWss: false,
  isQueryFetching: false,
  isFetched: false,
  isActiveOrdersQueryError: false,
  isSellerKanbanFilterEnabled: false,
  kanbanFilterSearchInput: '',
  setKanbanFilterSearchInput: () => undefined,
  kanbanFilterDeliveryType: null,
  setKanbanFilterDeliveryType: () => undefined,
  isKanbanFilterSearchDebouncing: false,
})

const useActiveOrdersContext = () => {
  const context = useContext(ActiveOrdersContext)
  if (!context) {
    throw new Error(
      'useActiveOrdersContext must be used within ActiveOrdersContext'
    )
  }
  return context
}

export default useActiveOrdersContext
